/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isbackgroundblurringallowed3Inputs */

const en_entity_isbackgroundblurringallowed3 = /** @type {(inputs: Entity_Isbackgroundblurringallowed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Background Blurring Allowed`)
};

const de_entity_isbackgroundblurringallowed3 = /** @type {(inputs: Entity_Isbackgroundblurringallowed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrundunschärfe erlaubt`)
};

/**
* | output |
* | --- |
* | "Is Background Blurring Allowed" |
*
* @param {Entity_Isbackgroundblurringallowed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isbackgroundblurringallowed3 = /** @type {((inputs?: Entity_Isbackgroundblurringallowed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isbackgroundblurringallowed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isbackgroundblurringallowed3(inputs)
	return de_entity_isbackgroundblurringallowed3(inputs)
});
export { entity_isbackgroundblurringallowed3 as "entity_isBackgroundBlurringAllowed" }